import React from 'react';
import classNames from 'classnames';

import Spinner from '../Spinner/Spinner';

import styles from './LoadingOverlay.module.scss';

type Props = {
  transparentBackground?: boolean;
  inline?: boolean;
  background?: boolean;
};

const LoadingOverlay = ({ transparentBackground = false, inline = false, background = true }: Props): JSX.Element => {
  const className = classNames(styles.loadingOverlay, {
    [styles.transparent]: transparentBackground,
    [styles.fixed]: !inline,
    [styles.inline]: inline,
    [styles.background]: background,
  });

  return (
    <div className={className}>
      <Spinner size="medium" />
    </div>
  );
};
export default LoadingOverlay;
